// src/Solitaire.js
import React from 'react';

const SolitaireGame2 = () => {
  return (
    <div>
      <iframe
        src="https://www.squidbyte.com/games/spidersolitairewindowsxp/"
        title="Solitaire Windows XP"
        width="590"
        height="370"
        style={{ border: 'none' }}
      ></iframe>
    </div>
  );
};

export default SolitaireGame2;
